import { pipe } from 'fp-ts/es6/pipeable';
import * as _ from './internal';
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Lift an instance of `At` using an `Iso`
 *
 * @category constructors
 * @since 2.3.0
 */
export var fromIso = function (iso) { return function (sia) { return ({
    at: function (i) { return pipe(iso, _.isoAsLens, _.lensComposeLens(sia.at(i))); }
}); }; };
/**
 * @category constructors
 * @since 2.3.2
 */
export var atRecord = _.atRecord;
